export { VerticalGradientLine } from './vertical-gradient-line';
export type { VerticalGradientLineProps } from './vertical-gradient-line';
